import Immutable from 'immutable';

export const GET_REGIONS = 'takeback/api/REGIONS';
export const GET_REGIONS_SUCCESS = 'takeback/api/REGIONS_SUCCESS';
export const GET_REGIONS_FAILURE = 'takeback/api/REGIONS_FAILURE';

const initialState = Immutable.Map();

// Reducers
export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case GET_REGIONS_SUCCESS:
        return state.mergeDeep(action.regions.reduce((map, region) => {
            return map.set(region.get('id'), region);
        }, Immutable.Map()));
    default: return state;
    }
}

/* Selectors */
export function selectRegions(state) {
    return state.regions;
}

export function getRegion(state, region) {
    return state.regions.get(region);
}

// Actions
export function getRegions(params = {}, options = {}) {
    return Object.assign({ type: GET_REGIONS, params }, options);
}

export function getRegionsSuccess(regions) {
    return { type: GET_REGIONS_SUCCESS, regions };
}

export function getRegionsFailure(error) {
    return { type: GET_REGIONS_FAILURE, error };
}
